import { cn } from '@ophelos/ui/lib/utils';
import type { LucideIcon } from 'lucide-react';
import * as React from 'react';
import { Button } from '@ophelos/ui/components/button';

export interface PaymentOptionRowProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: LucideIcon;
  label: string;
  /** Shown beside the label, e.g. a discount badge. */
  badge?: React.ReactNode;
}

/** One way of paying, as an upright button: icon over label. Sits beside its siblings under the balance. */
export const PaymentOptionRow = React.forwardRef<HTMLButtonElement, PaymentOptionRowProps>(
  ({ className, icon: Icon, label, badge, ...props }, ref) => (
    <Button ref={ref} type="button" variant="outline" className={cn('rounded-xl stack h-auto! px-4 py-3', className)} {...props}>
      <Icon className="size-4.5 shrink-0 " />
      {label}
      {badge}
    </Button>
  ),
);

PaymentOptionRow.displayName = 'PaymentOptionRow';
